import ipRegex from 'ip-regex';
import { Netmask } from 'netmask';

const PRIVATE_BLOCKS = [
  new Netmask('10.0.0.0/8'),
  new Netmask('172.16.0.0/12'),
  new Netmask('192.168.0.0/16'),
  new Netmask('100.64.0.0/10'),
];

// match an ipv4 address
export const ipv4Regex = ipRegex.v4({ exact: true });
// match an ipv4 address or `ipv4 address:port`
export const ipv4OptionalPortRegex = new RegExp(`^(?:${ipRegex.v4().source})(?::([0-9]{1,5}))?$`);
// match a `ipv4 address:port`
export const ipv4RequiredPortRegex = new RegExp(`^(?:${ipRegex.v4().source})(?::([0-9]{1,5}))$`);

// match a bare ipv6 address
export const ipv6Regex = ipRegex.v6({ exact: true });
// match an `[ipv6 address]`
export const ipv6BracketedRegex = new RegExp(`^\\[${ipRegex.v6().source}\\]$`);
// match an ipv6 address or `[ipv6 address]:port`
export const ipv6OptionalPortRegex = new RegExp(
  `(?:^${ipRegex.v6().source}$)|(?:^\\[${ipRegex.v6().source}\\]:([0-9]{1,5})$)`
);
// match a `[ipv6 address]:port`
export const ipv6RequiredPortRegex = new RegExp(`(?:^\\[${ipRegex.v6().source}\\]:([0-9]{1,5})$)`);

export function isPrivate(netmask: Netmask) {
  return PRIVATE_BLOCKS.some((privateBlock) => privateBlock.contains(netmask));
}
